module.exports = __webpack_public_path__ + "img/colaboration-of-accec.98b06aa5.jpg";